module.exports = __webpack_public_path__ + "static/media/choosing_ru.fc6ecb1f.svg";